import e from "../../../constants/screen.js";
const r = {
  props: {
    /**
         * Component's screen
         * Possible values are: 'small', 'medium', 'large'
         */
    screen: {
      type: String,
      default: e.small.name,
      validator: (n) => [e.small.name, e.medium.name, e.large.name].includes(n)
    }
  },
  computed: {
    isScreenLarge() {
      return this.screen === e.large.name;
    },
    isScreenMedium() {
      return this.screen === e.medium.name;
    },
    isScreenSmall() {
      return this.screen === e.small.name;
    }
  }
}, m = r;
export {
  m as default
};
